import { PRODUCT_NAME_FULL } from "@/config";
import { RuleDemo } from "./RuleDemo";
import { RuleSimulator } from "./RuleSimulator";

const STEPS: ReadonlyArray<{ n: string; title: string; body: string; filled: boolean }> = [
  { n: "1", title: "Satz schreiben", body: "In Ihren Worten, ohne Formularlogik.", filled: false },
  { n: "2", title: "System validiert", body: "Der Satz wird in eine präzise, prüfbare Regeländerung übersetzt — oder abgelehnt, wenn er mehrdeutig ist.", filled: false },
  { n: "3", title: "Simulation an echten Fällen", body: "Sie sehen vor der Aktivierung, welche vergangenen Anfragen sich anders entschieden hätten — Fall für Fall.", filled: false },
  { n: "4", title: "Mensch aktiviert", body: "Erst die Freigabe erzeugt eine neue, auditierte Regelversion. Jede Entscheidung verweist darauf.", filled: true },
];

/** Section #regeln: the killer-feature spotlight (typing demo + four steps) and the simulator. */
export function Regelwerk() {
  return (
    <section id="regeln" style={{ padding: "clamp(64px,9vw,110px) 24px" }}>
      <div style={{ maxWidth: "1120px", margin: "0 auto" }}>
        <p style={{ margin: "0 0 14px", fontSize: "13px", fontWeight: 600, letterSpacing: ".09em", textTransform: "uppercase", color: "var(--accent)" }}>Das Regelwerk</p>
        <h2 style={{ margin: "0 0 16px", fontSize: "clamp(28px,3.8vw,40px)", fontWeight: 600, lineHeight: 1.16, letterSpacing: "-.012em", textWrap: "pretty" }}>Regeln ändern? Schreiben Sie einen Satz.</h2>
        <p style={{ margin: "0 0 48px", fontSize: "16.5px", lineHeight: 1.68, color: "var(--muted)", maxWidth: "42em", textWrap: "pretty" }}>Neue Geschäftsregel, kein IT-Ticket: Sie beschreiben die Änderung in Ihren Worten. {PRODUCT_NAME_FULL} validiert sie, simuliert sie gegen Ihre bisherigen Anfragen — und erst ein Mensch aktiviert die neue, auditierte Version.</p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "clamp(30px,5vw,60px)", alignItems: "flex-start", marginBottom: "clamp(40px,6vw,64px)" }}>
          <RuleDemo />
          <div style={{ flex: "1 1 300px", minWidth: 0, display: "flex", flexDirection: "column", gap: "24px", paddingTop: "6px" }}>
            {STEPS.map((step) => (
              <div key={step.n} style={{ display: "flex", gap: "14px" }}>
                <span
                  style={
                    step.filled
                      ? { width: "30px", height: "30px", borderRadius: "50%", background: "var(--brand-deep)", color: "var(--on-deep)", display: "grid", placeItems: "center", fontSize: "13px", fontWeight: 700, flex: "none" }
                      : { width: "30px", height: "30px", borderRadius: "50%", border: "1.5px solid rgba(var(--ink-rgb),.2)", display: "grid", placeItems: "center", fontSize: "13px", fontWeight: 700, color: "var(--text)", flex: "none" }
                  }
                >
                  {step.n}
                </span>
                <div>
                  <h3 style={{ margin: "0 0 4px", fontSize: "16px", fontWeight: 600 }}>{step.title}</h3>
                  <p style={{ margin: 0, fontSize: "14.5px", lineHeight: 1.6, color: "var(--muted)" }}>{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <RuleSimulator />
      </div>
    </section>
  );
}
